import React from 'react';

import PageHero from '@/components/PageHero';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const termsData = [
  {
    title: "1. Agreement to Terms",
    content: "By creating an account and using the ALTA-X platform, you are entering into a legally binding agreement with 1st Group Capital (Pty) Ltd. These Terms of Service govern your access to and use of our platform and services. You agree to comply with these terms, our Privacy Policy, and all applicable South African laws and regulations. If you do not agree with any part of these terms, you must cease using our services immediately."
  },
  {
    title: "2. Eligibility and Account Security",
    content: "To use our services, you must be at least 18 years old and meet our client onboarding requirements, including identity verification under FICA. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account or any other breach of security."
  },
  {
    title: "3. Service Provision and Limitations",
    content: "ALTA-X provides an execution-only platform for investing in Contracts for Difference (CFDs). We do not provide financial, investment, or tax advice. The information on our platform is not a recommendation to invest. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without notice. We are not liable for any losses resulting from service interruptions or market volatility."
  },
  {
    title: "4. User Conduct and Prohibited Activities",
    content: "You agree not to use the ALTA-X platform for any unlawful purpose or in any way that could harm the platform, our services, or other users. Prohibited activities include, but are not limited to, market manipulation, insider trading, fraudulent activities, and attempting to reverse engineer our technology. Violation of these rules may result in immediate suspension or termination of your account and legal action."
  },
  {
    title: "5. Intellectual Property",
    content: "All content, trademarks, logos, and software on the ALTA-X platform are the exclusive property of 1st Group Capital (Pty) Ltd and are protected by intellectual property laws. You are granted a limited, non-exclusive, non-transferable license to access and use the platform for personal investment purposes. You may not copy, modify, distribute, or create derivative works from our content without our express written permission."
  },
  {
    title: "6. Limitation of Liability and Indemnification",
    content: "To the fullest extent permitted by law, 1st Group Capital (Pty) Ltd and its affiliates shall not be liable for any indirect, incidental, special, or consequential damages, including loss of profits, data, or goodwill, arising from your use of the ALTA-X platform. You agree to indemnify and hold harmless 1st Group Capital (Pty) Ltd from any claims, damages, or losses resulting from your violation of these Terms of Service or your use of the platform."
  }
];

const TermsOfService: React.FC = () => {
  return (
    <>
      <main className="flex-grow">
        <PageHero 
          title="Terms of Service"
          subtitle="Please read these terms carefully before using our services. By using our platform, you agree to be bound by these terms."
          backgroundImage="https://images.unsplash.com/photo-1589216532372-1c2a36790049?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        />
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible defaultValue="item-1" className="w-full">
              {termsData.map((item, index) => (
                <AccordionItem value={`item-${index + 1}`} key={index}>
                  <AccordionTrigger className="text-left">{item.title}</AccordionTrigger>
                  <AccordionContent className="prose prose-lg max-w-none text-gray-600">
                    <p>{item.content}</p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </main>
    </>
  );
};

export default TermsOfService;
